import { useData } from "@hooks/useData";
import Http from "@core/fetch";
import { components } from "@apiSchema";
import { iFoodLtoSection, FoodLtoSection } from "@models/FoodLtoSection";

async function getLaunches(word: string, secondaryWord: string = ''): Promise<iFoodLtoSection> {
    const params: any = {
        word,
    };

    if (secondaryWord?.trim() !== '') {
        params['secondaryWord'] = secondaryWord;
    }

    const response: components["schemas"]["ProfileLtoViewModel"] = await Http.get("get food profile launches", params);
    try {
        return new FoodLtoSection(response);
    } catch (err) {
        console.error(err);
        return new FoodLtoSection();
    }
}

export default function useFoodLaunches(searchQuery: string) {
    return useData(new FoodLtoSection(), getLaunches, searchQuery);
}

const idleFetchFn = async () => Promise.resolve(new FoodLtoSection());

export function useFoodLaunchesWithSearch(searchQuery: string, secondaryQuery: string) {
    const fetchFn = secondaryQuery.trim() === '' ? idleFetchFn : getLaunches;
    return useData(new FoodLtoSection(), fetchFn, searchQuery, secondaryQuery);
}
